var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGift3DarkMode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4761 18.4668H3.52334C2.93244 18.4653 2.45373 17.9868 2.45215 17.3958V8.89521C2.45215 8.75056 2.56941 8.6333 2.71405 8.6333H17.2854C17.43 8.6333 17.5473 8.75056 17.5473 8.89521V17.3958C17.5457 17.9868 17.067 18.4653 16.4761 18.4668Z",
    fill: "url(#paint0_linear_3681_106767)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.86947 9.04989V17.3951C2.8707 17.7563 3.16325 18.0488 3.52445 18.05H16.4763C16.8375 18.0488 17.13 17.7564 17.1313 17.3952C17.1313 17.395 17.1313 17.3953 17.1313 17.3952V9.04989H2.86947ZM2.03613 8.89512C2.03613 8.52036 2.33994 8.21655 2.7147 8.21655H17.286C17.6608 8.21655 17.9646 8.52036 17.9646 8.89512V17.3958L17.9646 17.3969C17.9624 18.2171 17.298 18.8814 16.4778 18.8834H3.52298C2.70279 18.8814 2.03833 18.2171 2.03613 17.3969L2.03613 17.3958V8.89512Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97656 9.15698V17.3957C2.97685 17.6981 3.22187 17.9431 3.52421 17.9434H16.4767C16.7789 17.9429 17.0238 17.698 17.0241 17.3957V9.15698H2.97656Z",
    fill: "url(#paint1_linear_3681_106767)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5005 9.1569H1.50079C1.13295 9.15661 0.834706 8.85872 0.833984 8.49088V6.46635C0.834418 6.09831 1.13275 5.80009 1.50079 5.7998H18.5005C18.8686 5.80009 19.1669 6.09831 19.1673 6.46635V8.49088C19.1666 8.85872 18.8683 9.15661 18.5005 9.1569Z",
    fill: "url(#paint2_linear_3681_106767)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50047 5.3833L18.5002 5.3833C19.098 5.38377 19.583 5.86818 19.5837 6.46602V8.49104C19.5825 9.08855 19.098 9.57326 18.5005 9.57373H1.50047C0.902953 9.57326 0.418165 9.08937 0.416993 8.49186L0.416992 6.46652C0.417696 5.86867 0.902622 5.38377 1.50047 5.3833ZM18.5 6.21663H1.50067C1.36255 6.21681 1.25059 6.3287 1.25033 6.46681V8.49053C1.25076 8.6285 1.36263 8.74019 1.50062 8.7404C1.50056 8.7404 1.50068 8.7404 1.50062 8.7404L18.4999 8.7404C18.4998 8.7404 18.4999 8.7404 18.4999 8.7404C18.6378 8.74019 18.7498 8.62862 18.7503 8.49075C18.7503 8.49057 18.7503 8.49093 18.7503 8.49075V6.46701C18.7502 6.3288 18.6382 6.21681 18.5 6.21663Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50042 6.32373C1.42155 6.32373 1.35757 6.38759 1.35742 6.46647V8.49099C1.35757 8.56987 1.42155 8.63373 1.50042 8.63373H18.5001C18.579 8.63373 18.643 8.56987 18.6431 8.49099V6.46647C18.643 6.38759 18.579 6.32373 18.5001 6.32373L1.50042 6.32373Z",
    fill: "url(#paint3_linear_3681_106767)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50702 18.3888H11.4927C11.6374 18.3888 11.7546 18.2738 11.7546 18.1318V8.9965C11.7546 8.85456 11.6374 8.7395 11.4927 8.7395H8.50702C8.36238 8.7395 8.24512 8.85456 8.24512 8.9965V18.1318C8.24512 18.2738 8.36238 18.3888 8.50702 18.3888ZM11.2309 17.9428H8.769V9.15694H11.2309V17.9428Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87695 5.03265C9.86501 5.01634 9.85431 4.99895 9.84501 4.98061C9.84417 4.97894 9.84304 4.97716 9.84145 4.97527L7.21543 1.84307C7.20445 1.82998 7.1843 1.82998 7.17333 1.84307C7.16477 1.85328 7.16477 1.86816 7.17332 1.87837L9.79935 5.01057C9.80243 5.01424 9.80513 5.01614 9.80736 5.01733C9.80984 5.01865 9.81294 5.01971 9.81662 5.02016C9.83718 5.02268 9.85735 5.02687 9.87695 5.03265Z",
    fill: "url(#paint4_linear_3681_106767)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7758 1.63592C14.0785 2.07049 14.0591 2.65757 13.7189 3.0731L13.7197 3.07391L11.9944 5.27687C11.9915 5.28053 11.9884 5.2847 11.9855 5.28826C11.8593 5.43859 11.6834 5.5582 11.511 5.64797C11.3332 5.74053 11.1308 5.81589 10.9283 5.86362C10.7285 5.9107 10.5093 5.93558 10.3017 5.91245C10.2174 5.90304 10.1261 5.88305 10.0356 5.84979C9.9313 5.87003 9.8233 5.86871 9.71576 5.84735L9.63845 5.83433C9.58725 5.82327 9.53681 5.8076 9.4879 5.78713L9.41547 5.75295C9.34397 5.71482 9.27711 5.66643 9.21771 5.60809L9.16075 5.54624L8.98659 5.33791L8.65945 5.59995L6.27338 2.62062L6.27419 2.61981C5.93144 2.20422 5.91078 1.61508 6.21397 1.17938L6.27989 1.09393C6.75715 0.524679 7.63287 0.524681 8.11013 1.09393L10.187 3.57033L11.8805 1.55047C12.3577 0.981225 13.2335 0.981221 13.7107 1.55047L13.7758 1.63592ZM9.84515 4.98065C9.84436 4.9791 9.84332 4.9775 9.8419 4.97576L7.21576 1.84344C7.20478 1.83035 7.18442 1.83035 7.17344 1.84344C7.16512 1.85361 7.16504 1.86831 7.17344 1.87843L9.79958 5.01076C9.80265 5.01441 9.80549 5.01608 9.80772 5.01727C9.81015 5.01857 9.81308 5.02006 9.81667 5.02052C9.83711 5.02303 9.85739 5.02701 9.87689 5.03273C9.865 5.01647 9.85442 4.99893 9.84515 4.98065ZM13.3917 2.81675L13.0719 2.54901C13.1843 2.41492 13.1843 2.22004 13.0719 2.08595L12.796 2.31707L12.5193 2.08595L10.5108 4.48016C10.5403 4.51971 10.5671 4.56064 10.589 4.60386C10.6731 4.74338 10.7134 4.90051 10.7086 5.05796C10.7181 5.05591 10.7282 5.05454 10.7379 5.05226C10.8742 5.02008 11.0109 4.96898 11.1261 4.90903C11.2446 4.8473 11.3157 4.78942 11.3458 4.75441L12.9938 2.65073C13.0268 2.63106 13.0578 2.607 13.0849 2.57668L13.2908 2.73781L13.3917 2.81675ZM13.0637 2.5604L12.9938 2.65073C12.8352 2.74507 12.6238 2.7185 12.4973 2.56772L12.796 2.31707L13.0719 2.54901C13.0689 2.55257 13.0666 2.55674 13.0637 2.5604L13.0849 2.57586V2.57668L13.0637 2.5604ZM13.2908 2.73781L13.0849 2.57586L13.0939 2.56772L13.3836 2.80942L13.2908 2.73781Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.86133 5.62494C10.0222 5.81679 10.3173 5.8168 10.4782 5.62494L13.1042 2.49274C13.2296 2.34316 13.2296 2.12517 13.1042 1.97559C12.9433 1.78373 12.6482 1.78373 12.4874 1.97559L10.1799 4.72785C10.1662 4.70088 10.1493 4.6751 10.1292 4.65109L7.50314 1.51889C7.34229 1.32704 7.04716 1.32704 6.88631 1.51889C6.76091 1.66847 6.7609 1.88647 6.88631 2.03604L9.51234 5.16824C9.58112 5.25028 9.67446 5.29724 9.77135 5.30912C9.75558 5.41925 9.78557 5.53458 9.86133 5.62494Z",
    fill: "url(#paint5_linear_3681_106767)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8168 2.25181C12.8254 2.2416 12.8254 2.22673 12.8168 2.21652C12.8058 2.20342 12.7857 2.20342 12.7747 2.21652L10.4672 4.96877C10.3863 5.06533 10.2623 5.11477 10.1371 5.1004C10.1155 5.09792 10.0944 5.0936 10.0739 5.08757C10.1318 5.16656 10.1565 5.26516 10.1426 5.36228C10.1414 5.37038 10.1436 5.37796 10.1487 5.38401C10.1597 5.3971 10.1798 5.3971 10.1908 5.38401L12.8168 2.25181ZM9.8773 4.9494C9.86536 4.93309 9.85466 4.9157 9.84537 4.89735C9.84452 4.89568 9.84339 4.8939 9.8418 4.89202L7.21578 1.75982C7.2048 1.74673 7.18465 1.74673 7.17368 1.75982C7.16512 1.77003 7.16512 1.78491 7.17368 1.79512L9.7997 4.92731C9.80278 4.93099 9.80548 4.93289 9.80772 4.93408C9.81019 4.9354 9.81329 4.93645 9.81697 4.9369C9.83753 4.93942 9.8577 4.94362 9.8773 4.9494ZM13.3916 1.73466C13.6338 2.02361 13.6338 2.44472 13.3916 2.73367L10.7655 5.86586C10.4548 6.23649 9.88469 6.23648 9.57396 5.86586C9.5012 5.77907 9.45817 5.7286 9.45817 5.67326C9.3859 5.62998 9.28241 5.47767 9.22497 5.40917L6.59894 2.27697C6.35669 1.98803 6.35669 1.56691 6.59894 1.27797C6.90967 0.907344 7.47978 0.907345 7.79051 1.27797L10.1867 4.13602L12.2 1.73466C12.5107 1.36404 13.0808 1.36404 13.3916 1.73466Z",
    fill: "url(#paint6_linear_3681_106767)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 10H10.8337V17.5H9.16699V10Z",
    fill: "url(#paint7_linear_3681_106767)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3681_106767",
    x1: 10.9203,
    y1: -6.02576,
    x2: -3.6969,
    y2: 18.3513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D81A78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3681_106767",
    x1: -17.2269,
    y1: 6.86244,
    x2: -7.86981,
    y2: 31.9992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D81A78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3681_106767",
    x1: -25.5334,
    y1: 4.92311,
    x2: -24.3557,
    y2: 15.7298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D81A78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3681_106767",
    x1: -23.5033,
    y1: 5.72048,
    x2: -22.9086,
    y2: 13.1975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D81A78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3681_106767",
    x1: 10.5847,
    y1: -2.76819,
    x2: 3.546,
    y2: 0.780116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D81A78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3681_106767",
    x1: 16.2594,
    y1: -4.02326,
    x2: 1.02861,
    y2: 3.30056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D81A78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3681_106767",
    x1: 16.9928,
    y1: -5.31971,
    x2: -0.312038,
    y2: 2.62033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D81A78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3681_106767",
    x1: 6.76996,
    y1: 8.04139,
    x2: 14.7757,
    y2: 11.0307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D81A78"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGift3DarkMode);
export default __webpack_public_path__ + "static/media/icGift3DarkMode.09930d6b52e2c35a2e72a59388aae7e1.svg";
export { ForwardRef as ReactComponent };